import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CTASection() {
  return (
    <section className="relative overflow-hidden border-t border-zinc-800/80" data-testid="cta-section">
      <div className="grid-lines absolute inset-0" aria-hidden="true" />
      <div
        className="absolute -top-40 left-1/2 h-80 w-[42rem] -translate-x-1/2 rounded-full bg-volt/[0.07] blur-[120px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-36">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-volt">
            {"// Next release"}
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-5 max-w-4xl font-display text-5xl font-extrabold leading-[0.98] tracking-tighter text-zinc-100 sm:text-6xl lg:text-7xl">
            Ready to release with <span className="text-volt">confidence?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400 sm:text-lg">
            Tell us about your product, release cycle and testing challenges.
            We'll help you identify where QA can make the biggest impact.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <Link
            to="/contact"
            data-testid="cta-consultation-button"
            className="group mt-10 inline-flex items-center gap-2 rounded-full bg-volt px-8 py-4 text-sm font-semibold text-black transition-transform duration-300 hover:scale-[1.03] active:scale-[0.98]"
          >
            Get a Free QA Consultation
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
